import { Box, Stack, Skeleton, styled } from '@mui/material';
import { ComponentProps } from 'react';
import { LoadingButton } from 'components';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}));

export const TracklistContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const ConfirmButtonBase = styled(LoadingButton)(({ theme }) => ({
  alignSelf: 'flex-end',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    alignSelf: 'center',
  },
}));

export const ConfirmButton = (
  props: ComponentProps<typeof ConfirmButtonBase>
) => <ConfirmButtonBase variant="contained" {...props} />;

export const CircularProgressContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

export const ConfirmButtonSkeletonBase = styled(Skeleton)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'flex-end',
  height: theme.spacing(5),
  width: theme.spacing(20),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    alignSelf: 'center',
  },
}));

export const ConfirmButtonSkeleton = (
  props: ComponentProps<typeof ConfirmButtonSkeletonBase>
) => <ConfirmButtonSkeletonBase variant="rectangular" {...props} />;
